/*
 * Copyright (c) Fing. All rights reserved.
 */

export function getOsPrintableIconClass(osName) {
    if (!osName) return null;


    const os = osName.toLowerCase();
    if (os==='android') {
        return "fa-android";
    } else if (os==='macos' || os==='os x' || os==="ios" || os==="tvos" || os==="watchos") {
        return "fa-apple"
    } else if (os==='windows') {
        return "fa-windows";
    } else if (os.indexOf('ubuntu') !== -1) {
        return "fa-ubuntu";
    } else if (os.indexOf('suse') !== -1) {
        return "fa-linux";
    } else if (os.indexOf('redhat') !== -1) {
        return "fa-redhat";
    } else if (os.indexOf('fedora') !== -1) {
        return "fa-fedora";
    } else if (os.indexOf('centos') !== -1) {
        return "fa-centos";
    } else if (os.indexOf('linux') !== -1) {
        return "fa-linux";
    }
    return null;
}

export function getOsPrintableVersion(os, v) {
    if (!os || !v) return null;

    if (os==='Android') {

        if (v.startsWith("10")) return null;
        else if (v.startsWith("9")) return "Pie";
        else if (v.startsWith("8")) return "Oreo";
        else if (v.startsWith("7")) return "Nougat";
        else if (v.startsWith("6")) return "Marshmallow";
        else if (v.startsWith("5")) return "Lollipop";
        else if (v.startsWith("4.4")) return "KitKat";
        else if (v.startsWith("4.1")) return "Jelly Bean";
        else if (v.startsWith("4.0")) return "Ice Cream Sandwitch";
        else if (v.startsWith("3.0")) return "Honeycomb";
        else if (v.startsWith("2.3")) return "Gingerbread";
        else if (v.startsWith("2.2")) return "Froyo";

    } else if (os==='macOS' || os==='OS X') {

        if (v.startsWith("12.") || v.startsWith("21")) return "Monterey";
        else if (v.startsWith("11.") || v.startsWith("20")) return "Big Sur";
        else if (v.startsWith("10.15.") || v.startsWith("19")) return "Catalina";
        else if (v.startsWith("10.14.") || v.startsWith("18")) return "Mojave";
        else if (v.startsWith("10.13.") || v.startsWith("17")) return "High Sierra";
        else if (v.startsWith("10.12.") || v.startsWith("16")) return "Sierra";
        else if (v.startsWith("10.11.") || v.startsWith("15")) return "El Capitan";
        else if (v.startsWith("10.10.") || v.startsWith("14")) return "Yosemite";
        else if (v.startsWith("10.9.")  || v.startsWith("13")) return "Mavericks";
        else if (v.startsWith("10.8.")  || v.startsWith("12")) return "Mountain Lion";
        else if (v.startsWith("10.7.")  || v.startsWith("11")) return "Lion";
        else if (v.startsWith("10.6.")) return "Snow Leopard";
        else if (v.startsWith("10.5.")) return "Leopard";
        else if (v.startsWith("10.4.")) return "Tiger";

    }
    return null;
}

export function selectClassViews(nvf) {
    const classes = {
        standard: "",
        simple: "",
        technical: ""
    }

    switch (nvf) {
        case "NVF_STANDARD":
            classes.standard = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill active";
            classes.simple = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            classes.technical = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            break;
        case "NVF_SIMPLE":
            classes.standard = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            classes.simple = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill active";
            classes.technical = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            break;
        case "NVF_TECHNICAL":
            classes.standard = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            classes.simple = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            classes.technical = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill active";
            break;
        default:
            classes.standard = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill active";
            classes.simple = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            classes.technical = "btn btn-xs btn-outline-secondary btn-custom-toggle-primary flex-fill";
            break;
    }

    return classes;

}